import { gql } from '@lcs/shared/api';

export const getPresenceContactQuery = gql`
   query GetPresenceContactRegister(
      $first: Int!
      $filters: String
      $after: String
      $orderingOptions: [OrderingOption!]
   ) {
      extensionPhonesConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            extensionPhoneId
            displayName
            office
            onCall
            extension {
               name
               number
               extensionId
               departmentExtensionsConnection {
                  items {
                     departmentExtensionId
                     extensionId
                     departmentId
                     department {
                        departmentId
                        name
                        isActive
                        accountId
                     }
                  }
               }
            }
            dndStatus
            callDetail {
               callDetailId
               callDirectionTypeId
               callSegmentsConnection {
                  items {
                     callSegmentId
                     callDetailId
                     sourceExtensionId
                     extensionId
                     sourceExtension {
                        extensionId
                        extensionType {
                           name
                        }
                        name
                        number
                        extensionPhone {
                           extensionPhoneId
                           callDetailId
                        }
                     }
                     extension {
                        extensionId
                        extensionType {
                           name
                        }
                        name
                        number
                        extensionPhone {
                           extensionPhoneId
                           callDetailId
                        }
                     }
                     startDate
                     endDate
                     duration
                  }
               }
               destinationExtension {
                  extensionId
                  number
                  name
                  extensionPhone {
                     extensionPhoneId
                     callDetailId
                  }
               }
               destinationNumber
               phoneNumber {
                  phoneNumberId
                  phoneNumber
               }
               serverName
               startTime
               sipCallId
               sourceExtension {
                  extensionId
                  number
                  name
                  extensionPhone {
                     extensionPhoneId
                     callDetailId
                  }
               }
               sourceNumber
            }
         }
      }
   }
`;
